import * as Common from "../../commons/common"

export class SearchCondition{
  school_id: string = ""
  created_at_from: string = ""
  created_at_to: string = ""
  sheet_type: string = ""
}

export class Sheet{
  sheet_group_key: number
  name: string
  created_at: string
  school_id: number
  school_name: string
  sheet_type: number
  isSelected: boolean = false

  constructor(sheet: any){
    this.sheet_group_key = sheet.sheet_group_key;
    this.name = sheet.name;
    this.created_at = sheet.created_at;
    this.school_id = sheet.school_id;
    this.school_name = sheet.school_name;
    this.sheet_type = sheet.sheet_type;
  }
}